import { useTranslation } from '@i18n'
import { useState, useEffect } from 'react'
import { useRNApp } from '@libs/RNApp'

const useR18Alert = () => {
  const { t } = useTranslation('alert')
  const [shouldShow, setShouldShow] = useState(false)
  const title = t('R18AlertTitle')
  const description = t('R18AlertDescription')
  const noMessage = t('R18AlertNO')
  const yesMessage = t('R18AlertYES')
  const { isApp } = useRNApp()

  const handleNoClick = () => {
    window.location.href = '/'
  }
  const handleYesClick = () => {
    const value = JSON.stringify({
      value: true,
      // 60 分鐘後過期
      expired: new Date().getTime() + 60 * 60 * 1000,
    })
    window.localStorage.setItem('hasViewedR18Alert', value)
    setShouldShow(false)
  }

  useEffect(() => {
    const item = JSON.parse(window.localStorage.getItem('hasViewedR18Alert'))
    if (isApp || (item?.value && new Date().getTime() < item?.expired)) {
      setShouldShow(false)
      return
    }
    setShouldShow(true)
  }, [])

  return { title, description, noMessage, yesMessage, shouldShow, handleNoClick, handleYesClick }
}

export default useR18Alert
